export default __webpack_public_path__ + "static/men-technology-zoom-cell-7bba71482ee49f82fade28ac4cc98599.png";